/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import Rs from './rs';
import Ms from './ms';
import Sv from './sv';
import Mb from './mb';
import Pt from './pt';
import Gd from './gd';
import Ex from './ex';
import Ce from './ce';
import Stat from './stat';
import Fn from './fn';

export const Api = {
    Rs,
    Ms,
    Sv,
    Mb,
    Pt,
    Gd,
    Ex,
    Ce,
    Stat,
    Fn,
};
export default Api;
